import { createAsyncThunk } from '@reduxjs/toolkit';

import { NotificationService } from '../../services';

export const fetchNotifications = createAsyncThunk(
  'notifications/fetchNotifications',
  async (params, { rejectWithValue }) => {
    try {
      const response = await NotificationService.getNotifications(params);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch notifications');
    }
  }
);

export const fetchNotification = createAsyncThunk(
  'notifications/fetchNotification',
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const response = await NotificationService.fetchNotification(id, params);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch notification');
    }
  }
);

export const clearNotification = createAsyncThunk(
  'notifications/clearNotification',
  async (id, { rejectWithValue }) => {
    try {
      await NotificationService.clearNotification(id);

      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to clear notification');
    }
  }
);

export const snoozeNotification = createAsyncThunk(
  'notifications/snoozeNotification',
  async (id, { rejectWithValue }) => {
    try {
      await NotificationService.snoozeNotification(id);

      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to snooze notification');
    }
  }
);
